import { render } from "./CDate.vue?vue&type=template&id=0ea28fd4"
import script from "./CDate.vue?vue&type=script&lang=js"
export * from "./CDate.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__